export const MESSAGE_COUNT = "message-count";

export const MESSAGES_CONSTS = {
  MSG_CTX_ERROR: "useMessageCtx must be used within a MessageCtxProvider",
  USER_NOT_FOUND: "User not found",
  USER_EXIST: "User already exist",
  JOIN_ROOM: "join-room",
  TAB_MSG: "tab-message",

  CONSTS: {
    MESSAGE: "message",
    DELETE: "delete",
    GROUP: "Group",
    ADD_GROUP_TITLE: "Create a Group",
    DELETE_MSG: "Delete Message",
    DELETE_GROUP: "Delete Group",
    ADD_MEMBER: "Add Member",
    REMOVE_MEMBER: "Remove Member",
  },
  BUTTONS: {
    CANCEL: "Cancel",
    DELETE: "Delete",
    UPDATE: "Update",
    CREATE_GROUP: "Create Group",
  },

  MESSAGES: {
    NO_USER: "No user found",
    SEARCH_SUGGESTION:
      "Use keywords that help others quickly recognize the purpose of the channel.",
    GROUP_CREATED: "Group created successfully",
    MEMBER_ADDED: "Member added successfully",
    MEMBER_REMOVED: "Member removed successfully",
    SELECT_MEMBER: "Please select a member",
    MSG_DELETE_WARN:
      "Are you sure you want to delete this message? This cannot be undone.",
    GROUP_DELETED: "Group Deleted Successfully.",
    GROUP_NAME_UPDATED: "Group name updated successfully.",
  },
  EMPTY: {
    BODY_TITLE: "It's nice to chat with someone.",
    BODY_SUBTITLE: "Pick a person from left menu",
    BODY_SUBTITLE2: "and start your conversation",
    NO_MSG: "No messages,yet.",
    NO_MSG_DESC: "Be the one to break the ice.",
    NO_MEDIA: "No media appears to be available.",
    NO_FILES: "No files appears to be available.",
  },
};
// Socket Room for chats

export enum RoomType {
  USER_CHAT = "user-chat",
  GROUP_CHAT = "group-chat",
}

export const EditGroupTabs = [
  {
    id: 1,
    name: "Members",
    value: "members",
  },
  {
    id: 2,
    name: "Media",
    value: "media",
  },
  {
    id: 3,
    name: "Files",
    value: "files",
  },
];

export const defaultPagination = {
  limit: 20,
  offset: 0,
  currentPage: 0,
  totalResult: 0,
};
